//Models
PJQ.models.projectMessages = {};

PJQ.models.projectMessages.ProjectMessagesResponse = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('projectId')
			},
			{
				endpoint: 'projectmessages'
			}
		])
	},
	parse: function (model) {
		this.messages = new PJQ.collections.projectMessages.ProjectMessages(model.messages);
		this.contactGroups = new PJQ.collections.projectMessages.ProjectContactGroups(model.contactGroups);
		return model;
	},
	getContextMessage: function(){
		let contextMessage = null;
		if (_.size(this.messages.models) > 0) {
			let sessionMessage = this.messages.findWhere({accessKey: PJQ.app.session.get('accessKey').toUpperCase()});
			if (sessionMessage != null && sessionMessage.canChangeStatus()) {
				contextMessage = sessionMessage;
			}

			if(contextMessage == null){
				// try to find newest Project Message not responded to yet and open its accordion
				let noResponseMessages = this.messages.getChangeableMessages();
				if (_.size(noResponseMessages) > 0) {
					contextMessage = _.max(noResponseMessages, function (item) {
						return PJQ.helpers.dateHelpers.getDateDiff(new Date(), new Date(item.get('createdOn')));
					});
				}
				else {
					contextMessage = null;
				}
			}
		}
		return contextMessage;
	}
});

PJQ.models.projectMessages.ProjectMessage = PJQ.models.BaseModel.extend({
	idAttribute: 'projectMessageId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('projectId')
			},
			{
				endpoint: 'projectmessages',
				value: this.id
			}
		])
	},
	parse: function (model) {
		if (model.attachments)
			this.attachments = new PJQ.collections.files.Files(model.attachments);
		else
			this.attachments = new PJQ.collections.files.Files();
		return model;
	},
	canChangeStatus: function(){
		return ((this.get('type') === "PROJECT" && (this.get('canChange'))) ||
			(this.get('type') === "MESSAGE" && (this.get('canChange') || _.size(this.get('status')) === 0 || (this.get('status') === ("PENDING" || "UNSENT"))))
		)
	}
});

PJQ.models.projectMessages.ProjectContactGroup = PJQ.models.BaseModel.extend({
	idAttribute: 'groupId',
	parse: function (model) {
		return model;
	}
});

//Collections
PJQ.collections.projectMessages = {};

PJQ.collections.projectMessages.ProjectMessages = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.projectMessages.ProjectMessage,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'projectmessages'
			}
		])
	},
	getChangeableMessages: function(){
		return this.models.filter(function(message){
			return message.get('type') === "PROJECT" && (message.get('canChange') || _.size(message.get('status')) === 0 || (message.get('status') === ("PENDING" || "UNSENT")))
		});
	}
});

PJQ.collections.projectMessages.ProjectContactGroups = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.projectMessages.ProjectContactGroup,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'projectmessages'
			},
			{
				endpoint: 'accesskey',
				value: this.accessKey
			},
			{
				endpoint: 'response'
			}
		])
	}
});
